import palette from "../palette";

const MuiButton = {
  containedSecondary: {
    fontFamily: "BancoDoBrasil Textos",
    background: palette.secondary.main,
    color: palette.primary.main,
    fontWeight: 700,
  },
  textPrimary: {
    background: palette.button.primary.fill,
    color: palette.primary.main,
  },
  textSecondary: {
    background: palette.button.secondary.fill,
    color: palette.primary.main,
  },
  text: {
    color: palette.button.primary.text,
    fontWeight: 700,
  },
};

export default MuiButton;
